import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rotating-top-player" }
const _hoisted_2 = { class: "top-player-title" }
const _hoisted_3 = { class: "d-flex flex-column pa-3" }
const _hoisted_4 = { class: "role-header d-flex align-center mb-3" }
const _hoisted_5 = { class: "d-flex align-center" }
const _hoisted_6 = { class: "role-name" }
const _hoisted_7 = { class: "rating-value" }
const _hoisted_8 = { class: "d-flex align-center" }
const _hoisted_9 = { class: "teammate-profile-container" }
const _hoisted_10 = { class: "stats-container" }
const _hoisted_11 = { class: "winrate-container" }
const _hoisted_12 = { class: "games-count" }
const _hoisted_13 = { class: "d-flex align-center pa-3" }
const _hoisted_14 = { class: "no-data-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlayerIcon = _resolveComponent("PlayerIcon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_TeammateProfile = _resolveComponent("TeammateProfile")!
  const _component_WinrateDisplay = _resolveComponent("WinrateDisplay")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('stats.topPlayerTitle')), 1),
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (_ctx.currentRole && _ctx.topPlayer && !_ctx.loading)
          ? (_openBlock(), _createBlock(_component_v_card, {
              key: _ctx.currentRole,
              class: "top-player-card",
              onClick: _ctx.navigateToPlayerStats
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_PlayerIcon, {
                        icon: _ctx.currentRole,
                        class: "role-icon mr-2"
                      }, null, 8, ["icon"]),
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t(`roles.${_ctx.currentRole}`)), 1)
                    ]),
                    _createVNode(_component_v_spacer),
                    _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.topPlayer.rating), 1)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "crown-icon mr-2" }, "🏆", -1)),
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_TeammateProfile, {
                        teammateID: _ctx.topPlayer.userID
                      }, null, 8, ["teammateID"])
                    ]),
                    _createVNode(_component_v_spacer),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_WinrateDisplay, {
                          winrate: _ctx.topPlayer.winrate.toFixed(2)
                        }, null, 8, ["winrate"])
                      ]),
                      _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('stats.gamesPlayed', { count: _ctx.topPlayer.gamesCount })), 1)
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["onClick"]))
          : (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                key: 1,
                type: "image",
                class: "top-player-skeleton"
              }))
            : (_openBlock(), _createBlock(_component_v_card, {
                key: 2,
                class: "top-player-card no-data-card"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_13, [
                    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "no-data-icon mr-2" }, "🏆", -1)),
                    _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('stats.noTopPlayerData')), 1)
                  ])
                ]),
                _: 1
              }))
      ]),
      _: 1
    })
  ]))
}